import { useEffect, useRef } from 'react';

export const Toast = ({ icon, close, dissolve, text }) => {
  const toastRef = useRef(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (dissolve) {
        toastRef.current.classList.replace('in', 'out');
        toastRef.current.addEventListener('animationend', (e) => {
          close();
        });
      } else {
        close();
      }
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className='toast-n'>
      <span className={`toast-n-wrap${dissolve ? ' in' : ''}`} ref={toastRef}>
        {icon && <img src={icon} alt='경고' className='icon_t icon_t_warning' />}
        <span className='toast-text'>{text}</span>
      </span>
    </div>
  );
};
